import React, { useState, useLayoutEffect, useMemo, useEffect } from 'react';
import { Col, Button, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { ProfileDetails } from './components/ProfileDetails';
import { FoodList } from './components/FoodList';

import Chat from '../../assets/images/png/chat.png';
import ListIcon from '../../assets/images/png/list.png';

import { EmptyContainer } from '../layout/EmptyContainer';
import { CookMeals } from '../../store/cooksprofile/types';
import { Link } from 'react-router-dom';
import {
  CenterProps,
  calcCrow,
} from '../dashboard/components/DesktopMealCarousel';
import { usePosition } from 'use-position';

export interface CookProps {
  user: string;
  cook: string;
  meals: Array<CookMeals>;
  userdetails: any;
  userinfo: any;
  isGuest: boolean;
  active: boolean;
  changeActive: (key: string) => void;
}

export const Cook: React.FC<CookProps> = ({
  user,
  cook,
  meals,
  userdetails,
  userinfo,
  changeActive,
  isGuest,
  active,
}) => {
  const [width, setWidth] = useState<number>(0);

  const [cooksLocation, setCooksLocation] = useState<CenterProps>();
  const { t } = useTranslation();
  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  const isDesktop = width >= 768;

  const settings = useMemo(
    () => ({ enableHighAccuracy: true, timeout: 0, maximumAge: Infinity }),
    []
  );

  const watch = true;
  const { latitude, longitude } = usePosition(watch, settings);

  const cookLocation = () => {
    if (userdetails) {
      setCooksLocation({ ...userdetails?.location });
    }
  };
  useEffect(cookLocation, [userdetails]);

  const checkNoLocation =
    calcCrow(
      cooksLocation?.lat,
      cooksLocation?.lng,
      latitude,
      longitude
    ).toFixed(2) === NaN.toString();
  const loc = checkNoLocation
    ? userdetails.address.city
    : `${calcCrow(
        cooksLocation?.lat,
        cooksLocation?.lng,
        latitude,
        longitude
      ).toFixed(2)} km`;
  return (
    <Tabs
      defaultActiveKey="1"
      className="cooks-tabs-container"
      size="default"
      onChange={changeActive}
    >
      <Tabs.TabPane
        tab={
          <img src={user} alt="user" className={!active ? 'img-icon' : ''} />
        }
        key="1"
      >
        <ProfileDetails details={userdetails} />
        <div className="chat-button">
          <Link
            to={{
              pathname: '../chat/:',
              state: { user: userdetails, chatid: '' },
            }}
          >
            <Button
              shape="circle"
              icon={<img src={Chat} alt="chat" />}
              size="large"
            />
          </Link>
        </div>
      </Tabs.TabPane>
      <Tabs.TabPane
        tab={<img src={cook} alt="cook" className={active ? 'img-icon' : ''} />}
        key="2"
      >
        {meals.length > 0 ? (
          <div className={isDesktop ? 'food-grid-display' : ''}>
            {meals.map((item, i) => (
              <Col className="food-container" key={i}>
                <FoodList
                  title={item.title}
                  price={item.price}
                  schedule={item.schedule}
                  image={item.image}
                  meal={{ ...userinfo, ...item }}
                  isGuest={isGuest}
                  location={loc}
                />
              </Col>
            ))}
          </div>
        ) : (
          <EmptyContainer
            title={t('Currently the cooks have no added offer')}
            icon={ListIcon}
          />
        )}
      </Tabs.TabPane>
    </Tabs>
  );
};
